import type { InputHTMLAttributes, ReactNode } from 'react';
import { cn } from '@/utils/cn';

interface ChoiceProps extends Omit<InputHTMLAttributes<HTMLInputElement>, 'type' | 'size'> {
  label: ReactNode;
}

/** Radio button with an inline label, brand-coloured when checked. */
export function Radio({ label, className, ...rest }: ChoiceProps) {
  return (
    <label
      className={cn(
        'inline-flex cursor-pointer items-center gap-2 text-[15px] text-ink',
        className,
      )}
    >
      <input type="radio" className="size-4 accent-brand" {...rest} />
      {label}
    </label>
  );
}

/** `sm` for secondary options ("Remember me"); `md` for form fields. */
export function Checkbox({
  label,
  className,
  size = 'sm',
  ...rest
}: ChoiceProps & { size?: 'sm' | 'md' }) {
  return (
    <label
      className={cn(
        'inline-flex cursor-pointer items-center gap-2 text-ink',
        size === 'sm' ? 'text-xs' : 'text-[15px]',
        className,
      )}
    >
      <input
        type="checkbox"
        className={cn('accent-brand', size === 'sm' ? 'size-3.5' : 'size-4')}
        {...rest}
      />
      {label}
    </label>
  );
}
